// import FP from 'fingerprintjs2/fingerprint2';

// export const getFP = () => new Promise((resolve) => {
//   new FP().get(result => {
//     resolve({'result': result})
//   })
// })
import { Notification } from 'element-ui'
import axios from 'axios'
import router from '../../router'
import { assert } from '../../utils/warn'
import {API_ROOT} from './config'
import { getReToken, getToken, saveTokenAndReToken } from '../../utils/store'

async function repeatRequest (origin, config) {
  console.log('config', config, origin.defaults)
  assert(!!config, '重发请求发生错误')
  if (origin.defaults.httpAgent === config.httpAgent) delete config.httpAgent
  if (origin.defaults.httpsAgent === config.httpsAgent) delete config.httpsAgent
  // 重建请求，为了防止原请求的拦截器多次响应，不保留响应拦截器
  const http = axios.create()
  origin.interceptors.request.forEach((interceptor) => {
    http.interceptors.request.use(interceptor.fulfilled, interceptor.rejected)
  })
  return http.request(config)
}
async function refreshToken () {
  const http = axios.create({
    baseURL: API_ROOT,
    withCredentials: true
  })
  const response = await http.get('refresh_token', {
    headers: {
      'retoken': getReToken() || ''
    }
  })
  const {status, data} = response
  saveTokenAndReToken(data)
  // 需要重新登录时，将error code注入抛出的error中
  assert(status < 400, '请重新登录', {code: data.errCode, response})
}

export const helper = (http) => {
  http.interceptors.request.use(
    config => {
      if (!window.navigator.onLine) {
        console.log('网络请求失败，请检查您的网络设置')
        return Promise.reject({msg: '网络请求失败，请检查您的网络设置'})
      }
      return config
    }
  )
  http.interceptors.request.use(async (config) => {
    // const {result:fp} = await getFP()
    /* eslint-disable */
    // console.log('fp', fp)
    const {headers = {}} = config
    return {
      ...config,
      headers: {
        ...headers,
        'token': getToken()
        // 'yc-f': fp
        // 'X-YC-SIGN': sign
      }
    }
  })
  http.interceptors.response.use(async (response) => {
    const {status, data, headers, config} = response
    const {code, msg, errCode} = data
    console.log('errCode', errCode)
    if (errCode === 70025) {
      // refreshToken错误 直接跳转登录页面
      router.push({name: 'login'})
      Notification({
        title: '提示',
        message: msg,
        type: 'info'
      })
    } else if (errCode === 70020) {
      // 重刷
      await refreshToken()
      return repeatRequest(http, config)
    } else if (errCode){
      Notification({
        title: '失败',
        message: msg,
        type: 'error'
      })
    }
    assert(!errCode, msg || '服务器未知错误', { code: errCode, response })
    return {status, code, msg, data, headers}
  }, async (error) => {
      console.log('error', error.response)
    if (error.response.data.errCode === 70025) {
      // refreshToken错误 直接跳转登录页面
      router.push({name: 'login'})
      Notification({
        title: '提示',
        message: error.response.data.msg,
        type: 'info'
      })
    } else if (error.response.data.errCode === 70020) {
      const {config} = error.response
      // 重刷
      // await store.dispatch('refreshToken')
      await refreshToken()
      return repeatRequest(http, config)
    } else {
      Notification({
        title: '失败',
        message: error.response.data.msg,
        type: 'error'
      })
    }
    // const {shortMessage, message, code, response = {}} = error
    // throw Object.assign(error, {
    //   code,
    //   status: response.status,
    //   message: shortMessage || message
    // })
  })
  return http
}
